import { render, staticRenderFns } from "./Responsible.vue?vue&type=template&id=3a73854e&scoped=true"
import script from "./Responsible.vue?vue&type=script&lang=js"
export * from "./Responsible.vue?vue&type=script&lang=js"
import style0 from "./Responsible.vue?vue&type=style&index=0&id=3a73854e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73854e",
  null
  
)

export default component.exports